import React, { useState, useEffect, useRef } from 'react';
import { messagesForEvacuation } from '../helpers/messages';
import { getDatabase, ref, onValue } from "firebase/database";
import { generatePodcastScript, geocodeAddress, getPathTimes, getTravelExperienceEnglishSummary } from '../helpers/AI_functions';
import { getStorage, ref as storageRef, getDownloadURL } from "firebase/storage";
import { getFirestore, collection, getDocs } from 'firebase/firestore';
import { GoogleMap, LoadScript } from '@react-google-maps/api';
import { haversineDistance, dijkstra, reconstructPath, formatTime } from '../helpers/generalHelpers';
import { getTravelExperienceToDestinations, buildTravelNarrative } from '../helpers/route_functions';
import SafetyIcon from '../assets/images/safety_icon.png';
import LocationIcon from '../assets/images/user-location.png';
import FireImage from '../assets/images/fire_img.png'
import { width } from '@amcharts/amcharts4/.internal/core/utils/Utils';




// Replace with your actual API key.
const GOOGLE_MAPS_API_KEY = 'AIzaSyASU8wb6swDIo3dNxkyjfraWijCImc3-OU';

const firestore = getFirestore();

const containerStyle = {
  width: '100%',
  height: '740px'
};

const center = { lat: 37.892072, lng: -122.264514 };
const DEFAULT_LOCATION = { lat: 37.89693378501773, lng: -122.26147910272792 };

const darkMapStyle = [
  { elementType: "geometry", stylers: [{ color: "#242f3e" }] },
  { elementType: "labels.text.stroke", stylers: [{ color: "#242f3e" }] },
  { elementType: "labels.text.fill", stylers: [{ color: "#746855" }] },
  {
    featureType: "administrative.locality",
    elementType: "labels.text.fill",
    stylers: [{ color: "#d59563" }],
  },
  {
    featureType: "poi",
    elementType: "all",
    stylers: [{ visibility: "off" }],
  },
   {
    featureType: "landscape.natural",
    elementType: "geometry",
    stylers: [{ color: "#223322" }] // Use a dark green color
  },
  {
    featureType: "road",
    elementType: "geometry",
    stylers: [{ color: "#38414e" }],
  },
  {
    featureType: "road",
    elementType: "geometry.stroke",
    stylers: [{ color: "#212a37" }],
  },
  {
    featureType: "road",
    elementType: "labels.text.fill",
    stylers: [{ color: "#9ca5b3" }],
  },
  {
    featureType: "road.highway",
    elementType: "geometry",
    stylers: [{ color: "#746855" }],
  },
  {
    featureType: "road.highway",
    elementType: "geometry.stroke",
    stylers: [{ color: "#1f2835" }],
  },
  {
    featureType: "road.highway",
    elementType: "labels.text.fill",
    stylers: [{ color: "#f3d19c" }],
  },
  {
    featureType: "transit",
    elementType: "geometry",
    stylers: [{ color: "#2f3948" }],
  },
  {
    featureType: "transit.station",
    elementType: "labels.text.fill",
    stylers: [{ color: "#d59563" }],
  },
  {
    featureType: "water",
    elementType: "geometry",
    stylers: [{ color: "#17263c" }],
  },
  {
    featureType: "water",
    elementType: "labels.text.fill",
    stylers: [{ color: "#515c6d" }],
  },
  {
    featureType: "water",
    elementType: "labels.text.stroke",
    stylers: [{ color: "#17263c" }],
  },
];

const WORRIES = [
  { key: 'Pets', label: 'Pets' },
  { key: 'Livestock', label: 'Livestock' },
  { key: 'Kids', label: 'Kids' },
  { key: 'Large vehicles', label: 'Driving in large vehicles' },
  { key: 'HealthIssues', label: 'Health issues' },
  { key: 'OldRelatives', label: 'Elderly family members' },
];

const LANGUAGES = [
  { key: 'EN', label: 'English' },
  { key: 'ES', label: 'Spanish' },
  { key: 'MAND', label: 'Mandarin' },
];

// Destination nodes for shortest route search
const destinationNodes = [
  { nodeId: "43", name: "Hearst Ave - Oxford Street exit" },
  // { nodeId: "151" },
  { nodeId: "171", name: "Monterey Avenue exit" },
 // { nodeId: "187" },
 //{ nodeId: "188" },
  { nodeId: "191", name: "Exit near Summit Reservoir" },
  { nodeId: "195", name: "Arlington Avenue exit" },
  // { nodeId: "199" },
];


const routesAudioTimings = {
  Assumptions: 0,
  "Hearst Ave - Oxford Street exit": 60,        // 1 : 00
  "Monterey Avenue exit": 165,                  // 2 : 45  → 2*60+45
  "Exit near Summit Reservoir": 229,            // 3 : 49
  "Arlington Avenue exit": 315,                 // 5 : 15
  "Get your own personalized evacuation plan": 395 // 6 : 35
};

const routeChecklistItems = [
  { key: "Assumptions", title: "Assumptions" },
  { key: "43", nodeId: "43",  title: "Hearst Ave - Oxford Street exit" },
  { key: "171", nodeId: "171", title: "Monterey Avenue exit" },
  { key: "191", nodeId: "191", title: "Exit near Summit Reservoir" },
  { key: "195", nodeId: "195", title: "Arlington Avenue exit" },
  { key: "Plan",              title: "Get your own personalized evacuation plan" }
];

const WildfirePlanningPage = () => {
  // Existing states
  const [selectedWorries, setSelectedWorries] = useState([]);
  const [selectedLanguage, setSelectedLanguage] = useState('EN');
  const [selectedTab, setSelectedTab] = useState('routes');
  const [podcastStream, setPodcastStream] = useState("");
  const [podcastUploadPoint, setPodcastUploadPoint] = useState(null);
  const [podcastAudioUrl, setPodcastAudioUrl] = useState("");
  const [checkedItems, setCheckedItems] = useState({});
  const [travelExperiences, setTravelExperiences] = useState(null);
  const [travelExpNarrativeStream, setTravelExpNarrativeStream] = useState("");
  const mapRef = useRef(null);
  const podcastAudioRef = useRef(null);
  const safetyCalloutsRef = useRef([]);
  const [routesAudioUrl, setRoutesAudioUrl] = useState("");
  const routesAudioRef = useRef(null);
  const routesDataRef = useRef([]);   // ←  NEW
  const activeRouteNodeRef = useRef(null);   // remembers last highlight

  // Map section states
  const [time, setTime] = useState(0);
  const [selectedLocation, setSelectedLocation] = useState(DEFAULT_LOCATION);
  const [simulations, setSimulations] = useState([]);
  const [selectedSimulation, setSelectedSimulation] = useState(null);
  const [showPolyLines, setShowPolyLines] = useState(false);
  const [showAssumptions, setShowAssumptions] = useState(false);
  // Graph data state
  const [graphData, setGraphData] = useState({ links: [], nodes: {}, adjList: {} });
  // New state for car markers (if using Markers)
  const carMarkersRef = useRef([]);
  // We'll continue to use the existing polylineRefs.
  const polylineRefs = useRef([]);
  const circleRef = useRef(null);
  // New state to hold car overlays (if switching to OverlayView, see previous example)
  const [carOverlays, setCarOverlays] = useState([]);
  const [CalloutOverlayClass, setCalloutOverlayClass] = useState(null);

  const [searchText,      setSearchText]      = useState("");   // text in the bar
  const [isSearchingLoc,  setIsSearchingLoc]  = useState(false); // spinner flag


  // Pre-designated audio start times for checklist items (unchanged)
  const audioTimings = {
    // Alert section
    "Sign up to Alert Marin": 31,  
    "Evacuation order": 51,
    "Evacuation warning": 77,
    "Red flag day": 102,
    "Shelter in place": 124,
  
    // Go bag section
    "N95 respirator": 150,
    "Goggles": 176,
    "First aid kit": 195,
    "Key documents": 215,
    "Food and water supplies": 238,
    "Flashlight and radio": 261,
  
    // Pets section
    "Pet leashes": 287,
    "Carrier or crates": 305,
    "Pet food and water supplies": 332,
    "Pet medical supplies": 355,
    "Plan with neighbors": 374,
  };
  
  const displayLabels = {
    // Alert section
    "Sign up to Alert Marin": "Sign up to Alert Marin",
    "Evacuation order":     "Evacuation order",
    "Evacuation warning":   "Evacuation warning",
    "Red flag day":         "Red flag day",
    "Shelter in place":     "Shelter in place",
  
    // Go bag section
    "N95 respirator":       "N95 respirator",
    "Goggles":              "Goggles",
    "First aid kit":        "First aid kit",
    "Key documents":        "Key documents",
    "Food and water supplies":"Food and water supplies",
    "Flashlight and radio": "Flashlight and radio",
  
    // Pets section
    "Pet leashes":                   "Pet leashes",
    "Carrier or crates":             "Carrier or crates",
    "Pet food and water supplies":   "Pet food and water supplies",
    "Pet medical supplies":          "Pet medical supplies",
    "Plan with neighbors":           "Plan with neighbors",
  };

  // Fetch podcast audio URL on mount.
  useEffect(() => {
    const storage = getStorage();
    const podcastRefStorage = storageRef(storage, 'Podcast media/Marin Wildfire Safety Preparedness.wav');
    getDownloadURL(podcastRefStorage)
      .then((url) => { setPodcastAudioUrl(url); })
      .catch((error) => { console.error("Error fetching podcast audio:", error); });

  }, []);

  useEffect(() => {
    if (!selectedSimulation) return;
    const storage = getStorage();
    const csvRef  = storageRef(
      storage,
      `${selectedSimulation.id}/inputs/berkeley_links.csv`
    );
    getDownloadURL(csvRef)
      .then(u => fetch(u))
      .then(r => r.text())
      .then(csvText => { /* existing CSV‑parse logic */ })
      .catch(err => console.error('Error fetching CSV:', err));
  }, [selectedSimulation]);

  useEffect(() => {
    const fetchSimulations = async () => {
      try {
        const simsCol   = collection(firestore, 'simulations');
        const simDocs   = await getDocs(simsCol);
        const simList   = simDocs.docs.map(d => ({ id: d.id, ...d.data() }));
        setSimulations(simList);
        if (simList.length) setSelectedSimulation(simList[0]);   // default
      } catch (err) {
        console.error('Error fetching simulations:', err);
      }
    };
    fetchSimulations();
  }, []);

  useEffect(() => {
    const storage = getStorage();
    const evacAudioRef = storageRef(
      storage,
      "Podcast media/Wildfire Evacuation Simulation_ Grizzly Peak Traffic Analysis.wav"
    );
    getDownloadURL(evacAudioRef)
      .then((url) => setRoutesAudioUrl(url))
      .catch((err) => console.error("Error fetching routes audio:", err));
  }, []);

  useEffect(() => {
      // 1.  Whenever we LEAVE the Routes tab, reset the map immediately.
      if (selectedTab !== "routes") {
        updateRouteOpacity(null);          // full opacity
        return;                            // nothing to listen to
      }
    
      // 2.  The Routes tab is active → grab the *currently rendered* audio node
      const audio = routesAudioRef.current;
      if (!audio) return;   // it may be null on the very first render
    
      const handleTime = () => {
        const node = nodeIdForTime(audio.currentTime);
        if (node !== activeRouteNodeRef.current) {
          activeRouteNodeRef.current = node;
          updateRouteOpacity(node);
        }
      };
    
      const reset = () => {
        activeRouteNodeRef.current = null;
        updateRouteOpacity(null);          // full opacity
      };
    
      audio.addEventListener("timeupdate", handleTime);
      audio.addEventListener("pause", reset);
      audio.addEventListener("ended", reset);
    
      // Run once so opacity is correct even before the first 'timeupdate'
      handleTime();
    
      // 3.  Cleanup whenever the tab switches OR a new <audio> is mounted
      return () => {
        audio.removeEventListener("timeupdate", handleTime);
        audio.removeEventListener("pause", reset);
        audio.removeEventListener("ended", reset);
      };
    }, [selectedTab, routesAudioUrl]);  ; 

  // Fetch and parse CSV file on mount.
  useEffect(() => {
    const storage = getStorage();
    const csvRef = storageRef(storage, 'simulation_1/inputs/berkeley_links.csv');
    getDownloadURL(csvRef)
      .then(url => fetch(url))
      .then(response => response.text())
      .then(csvText => {
        const parsed = parseCSV(csvText);
        let nodes = {};
        parsed.forEach(row => {
          const startId = row.start_node_id;
          const endId = row.end_node_id;
          const geom = row.geometry;
          const coordsString = geom.replace(/LINESTRING\s*\(/, '').replace(/\)$/, '');
          const coordsArr = coordsString.split(',').map(s => s.trim().split(' ').map(Number));
          if (coordsArr.length > 0) {
            if (!nodes[startId]) {
              nodes[startId] = { id: startId, lat: coordsArr[0][1], lng: coordsArr[0][0] };
            }
            if (!nodes[endId]) {
              nodes[endId] = { id: endId, lat: coordsArr[coordsArr.length - 1][1], lng: coordsArr[coordsArr.length - 1][0] };
            }
          }
        });
        let adjList = {};
        parsed.forEach(row => {
          const start = row.start_node_id;
          const end = row.end_node_id;
          const length = parseFloat(row.length);
          if (!adjList[start]) adjList[start] = [];
          if (!adjList[end]) adjList[end] = [];
          adjList[start].push({ node: end, weight: length, link: row });
        });
        setGraphData({ links: parsed, nodes, adjList });
      })
      .catch(error => console.error("Error fetching CSV:", error));
  }, []);

  // CSV parser helper.
  const parseCSV = (text) => {
    const lines = text.split('\n').filter(line => line.trim() !== '');
    const header = lines[0].split(',');
    const data = [];
    const regex = /,(?=(?:(?:[^"]*"){2})*[^"]*$)/;
    for (let i = 1; i < lines.length; i++) {
      let row = lines[i].split(regex);
      const obj = {};
      header.forEach((col, index) => {
        obj[col] = row[index] ? row[index].replace(/^"|"$/g, '') : '';
      });
      data.push(obj);
    }
    return data;
  };

  const handleGetTravelExperience = async () => {
    if (!selectedLocation) {
      window.alert('Click on the map first to choose your starting point.');
      return;
    }
  
    try {
      const exp = await getTravelExperienceToDestinations({
        lat: selectedLocation.lat,
        lng: selectedLocation.lng,
        graphData,
        destinationNodes,
        selectedTime: Number(time),
        apiAbortSignal: apiCallControllerRef.current?.signal
      });
      console.log('Travel experience log:', exp);
      setTravelExperiences(exp);

      const narrative = buildTravelNarrative(exp, selectedLocation, Number(time));
      setTravelExpNarrativeStream(narrative);

      
      /* 
      
      const uploadPoint = Date.now();
  
      await getTravelExperienceEnglishSummary(
        exp,
        selectedLocation,
        Number(time),
        uploadPoint
      );


      const db = getDatabase();
      const evac_experience_content_ref = ref(
        db,
        `/generated_narrative/${uploadPoint}`
      );
      onValue(evac_experience_content_ref, (snapshot) => {
        const val = snapshot.val();
        console.log(val)
        if (val && typeof val === "string") {
          setTravelExpNarrativeStream(val);       // reuse existing audio/text display
        }
      });
      */

    } catch (err) {
      console.error('Could not get travel experience', err);
    }
  };

  const initialDrawDone = useRef(false);

  useEffect(() => {
    // run once, after the map, simulation list and graph have finished loading
    if (
      initialDrawDone.current ||
      !mapRef.current ||
      !selectedSimulation ||
      !graphData.nodes ||
      !Object.keys(graphData.nodes).length
    ) return;

    drawRoutes(
      DEFAULT_LOCATION.lat,
      DEFAULT_LOCATION.lng,
      time,
      selectedSimulation
    );
    initialDrawDone.current = true;
  }, [graphData, selectedSimulation]);

 

  // Function to play podcast audio.
  const playSection = (startTime) => {
    if (podcastAudioRef.current) {
      podcastAudioRef.current.currentTime = startTime;
      podcastAudioRef.current.play();
    }
  };

  const playRouteSection = (startTime) => {
    if (routesAudioRef.current) {
      routesAudioRef.current.currentTime = startTime;
      routesAudioRef.current.play();
    }
  };

  const createTextOverlay = (position, text) => {
    const overlay = new window.google.maps.OverlayView();
    overlay.onAdd = function() {
      this.div = document.createElement("div");
      // Style the overlay div as desired:
      this.div.style.position = "absolute";
      this.div.style.background = "rgba(255, 255, 255, 0.9)";
      this.div.style.color = "#000";
      this.div.style.padding = "2px 4px";
      this.div.style.borderRadius = "4px";
      this.div.style.fontSize = "16px";
      this.div.innerHTML = text;
      const panes = this.getPanes();
      panes.floatPane.appendChild(this.div);
    };
    overlay.draw = function() {
      const projection = this.getProjection();
      // Convert the geographical position to pixel coordinates.
      const point = projection.fromLatLngToDivPixel(new window.google.maps.LatLng(position.lat, position.lng));
      if (point && this.div) {
        // Adjust the position so the overlay appears centered above the marker.
        this.div.style.left = (point.x - this.div.offsetWidth / 2) + "px";
        this.div.style.top = (point.y - this.div.offsetHeight - 20) + "px"; // 5px above
      }
    };
    overlay.onRemove = function() {
      if (this.div) {
        this.div.parentNode.removeChild(this.div);
        this.div = null;
      }
    };
    overlay.setMap(mapRef.current);
    return overlay;
  };

  const apiCallControllerRef = useRef(null);

  const drawRoutes = async (lat, lng, selectedTime, selectedSimulation) => {
    // Cancel any ongoing API calls.
    if (apiCallControllerRef.current) {
      apiCallControllerRef.current.abort();
    }
    // Create a new controller for this set of API calls.
    apiCallControllerRef.current = new AbortController();

    // Draw a location marker using the LocationIcon.
    if (circleRef.current) {
      circleRef.current.setMap(null);
    }
    const locationMarker = new window.google.maps.Marker({
      position: { lat, lng },
      map: mapRef.current,
      icon: {
        url: LocationIcon,
        scaledSize: new window.google.maps.Size(50, 50),
        anchor: new window.google.maps.Point(25, 25),
      },
    });
    circleRef.current = locationMarker;

    // Clear existing polylines and car markers.
    polylineRefs.current.forEach(poly => poly.setMap(null));
    polylineRefs.current = [];
    carMarkersRef.current.forEach(marker => marker.setMap(null));
    carMarkersRef.current = [];
    routesDataRef.current = [];

    // Clear existing safety callouts.
    if (safetyCalloutsRef.current && safetyCalloutsRef.current.length > 0) {
      safetyCalloutsRef.current.forEach(callout => callout.setMap(null));
      safetyCalloutsRef.current = [];
    }

    if (!graphData.nodes || Object.keys(graphData.nodes).length === 0) return;

    console.log("Graph data:", graphData)

    // Find the nearest node to the click.
    let nearestNodeId = null;
    let minDist = Infinity;
    for (const node of Object.values(graphData.nodes)) {
      const d = haversineDistance(lat, lng, node.lat, node.lng);
      if (d < minDist) {
        minDist = d;
        nearestNodeId = node.id;
      }
    }
    console.log("Nearest node:", nearestNodeId);

    // Run Dijkstra from that node.
    const { distances, previous } = dijkstra(graphData.adjList, nearestNodeId);

    // Create an array to collect route data for all destinations.
    const routesData = [];

    // Process each destination.
    for (const dest of destinationNodes) {
      if (distances[dest.nodeId] < Infinity) {
        // Reconstruct the route (node IDs).
        const route = reconstructPath(previous, nearestNodeId, dest.nodeId);
        console.log(`Route to ${dest.nodeId}:`, route);

        // Convert node IDs to coordinates.
        const routeCoords = route.map(nodeId => {
          const node = graphData.nodes[nodeId];
          return { lat: node.lat, lng: node.lng };
        });

        // Build link IDs for the route.
        const pathLinks = [];
        for (let i = 0; i < route.length - 1; i++) {
          const currNodeId = route[i];
          const nextNodeId = route[i + 1];
          let linkId = null;
          if (graphData.adjList[currNodeId]) {
            const edge = graphData.adjList[currNodeId].find(e => e.node === nextNodeId);
            if (edge && edge.link) {
              linkId = edge.link.link_id; // Assumes CSV data contains "link_id"
            }
          }
          if (linkId !== null) {
            pathLinks.push(linkId);
          }
        }
        console.log("Path links for destination", dest.nodeId, ":", pathLinks);

        // Draw the route entirely in default blue.
        const routePolylines = [];
        for (let i = 0; i < routeCoords.length - 1; i++) {
          const polyline = new window.google.maps.Polyline({
            path: [routeCoords[i], routeCoords[i + 1]],
            geodesic: true,
            strokeColor: "#186EE3", // Blue for default
            strokeOpacity: 1,
            strokeWeight: 5,
            zIndex: -1000,
            clickable: true
          });
          polyline.setMap(mapRef.current);

          // show the link_id in console when this segment is clicked
          const currentLinkId = pathLinks[i];   // same order as segments
          polyline.addListener("click", () => {
            console.log(`Link ID: ${currentLinkId}`);
          });

          routePolylines.push(polyline);
          polylineRefs.current.push(polyline);
        }

        // Place a safety marker at the destination.
        const destinationPos = routeCoords[routeCoords.length - 1];
        const destMarker = new window.google.maps.Marker({
          position: destinationPos,
          map: mapRef.current,
          icon: {
            url: SafetyIcon,
            scaledSize: new window.google.maps.Size(40, 40),
            anchor: new window.google.maps.Point(20, 20),
          },
          opacity: 1
        });

        // log the nodeId when the flag is clicked
          destMarker.addListener('click', () => {
            console.log(`Destination node ID: ${dest.nodeId}`);
          });

        // Store this route for later API update.
        routesData.push({
          destNodeId: dest.nodeId,
          pathLinks,  
          routePolylines,
          destinationPos,
          destMarker
        });
      }
    } // end for each destination

    routesDataRef.current = routesData;

    // Fire off all API calls concurrently.
    await Promise.all(routesData.map(async (routeData) => {
      // Pass the abort signal from our controller.
      const apiResponse = await getPathTimes(routeData.pathLinks, selectedTime, selectedSimulation.id, selectedSimulation.isInteractiveMap, apiCallControllerRef.current.signal);
      // Update polyline colors based on traffic congestion.
      if (apiResponse && apiResponse.link_times) {
        apiResponse.link_times.forEach((linkData, idx) => {
          if (linkData.queued_vehicles >= 1 && routeData.routePolylines[idx]) {
            routeData.routePolylines[idx].setOptions({ strokeColor: "#FFA000" });
          }
        });
      }
      // Create a text overlay for total travel time.
      if (apiResponse && typeof apiResponse.total_time !== "undefined") {
        const totalTimeSeconds = Math.round(apiResponse.total_time) + Math.round(selectedTime);
        console.log("Calculating total time", "selectedTime:", selectedTime, "API response time:", apiResponse.total_time, "Total time:", totalTimeSeconds)
        const minutes = Math.floor(totalTimeSeconds / 60);
        const seconds = totalTimeSeconds % 60;
        const totalTimeStr = `${minutes}:${seconds < 10 ? "0" + seconds : seconds}`;
        const textOverlay = createTextOverlay(routeData.destinationPos, totalTimeStr);
        safetyCalloutsRef.current.push(textOverlay);
      }
    }));
  }

  const handleMapClick = async (e) => {

    const lat = e.latLng.lat();
    const lng = e.latLng.lng();

    setSelectedLocation({lat: lat, lng: lng})

    console.log("Map clicked at:", { lat, lng, time, selectedSimulation });

    drawRoutes(lat, lng, time, selectedSimulation)
    
  };



  const handleTimeChange = (e) => { 
    const newT = Number(e.target.value);
    setTime(newT);
    if (selectedLocation && selectedSimulation) {
      drawRoutes(selectedLocation.lat, selectedLocation.lng, newT, selectedSimulation);
    }

  };

  const togglePolylines = () => { setShowPolyLines(!showPolyLines); };

  const handleSimulationChange = (e) => {
    const simID = e.target.value;
    console.log(simID)
    const sim = simulations.find(s => s.id === simID);
    if (sim) setSelectedSimulation(sim);

    if (selectedLocation && selectedSimulation) {
       drawRoutes(selectedLocation.lat, selectedLocation.lng, time, sim);
    }
  };

  const loadFireOverlay = () => {
    // Add the fire marker here:
    // Define the fixed center and the offset in meters
    const fireCenter = { lat: 37.891993946041026, lng: -122.24859240728762 };
    const meters = 400; // adjust this value: approximately 150 meters covers 3 blocks
    const meterToDegLat = 1 / 111000; // roughly 1° latitude = 111 km
    // For longitude, adjust by the cosine of the latitude.
    const meterToDegLng = 1 / (111000 * Math.cos(fireCenter.lat * Math.PI / 180));
    const latOffset = meters * meterToDegLat;
    const lngOffset = meters * meterToDegLng;

    // Create bounds for the GroundOverlay.
    const bounds = new window.google.maps.LatLngBounds(
      new window.google.maps.LatLng(fireCenter.lat - latOffset, fireCenter.lng - lngOffset),
      new window.google.maps.LatLng(fireCenter.lat + latOffset, fireCenter.lng + lngOffset)
    );

    // Create and display the GroundOverlay using your FireImage.
    new window.google.maps.GroundOverlay(FireImage, bounds, { opacity: 0.75 }).setMap(mapRef.current);
  }

  const alertSection = {
    title: "Alerts",
    data: [
      {
        key: "Sign up to Alert Marin",
        title: "Sign up to Alert Marin",
        subtitle: "Sign up to receive wildfire alerts from Marin",
        audioTime: audioTimings["Sign up to Alert Marin"],
      },
      {
        key: "Evacuation order",
        title: "Evacuation order",
        subtitle: "Leave now. Failure to leave could impact operations to save life and property.",
        audioTime: audioTimings["Evacuation order"],
      },
      {
        key: "Evacuation warning",
        title: "Evacuation warning",
        subtitle: "Be prepared to leave. If living in one-way in/out areas or needing assistance, leave early.",
        audioTime: audioTimings["Evacuation warning"],
      },
      {
        key: "Red flag day",
        title: "Red flag day",
        subtitle: "Conditions for wildfire are high. Be alert and if needing assistance or living in hazard areas, leave before fire.",
        audioTime: audioTimings["Red flag day"],
      },
      {
        key: "Shelter in place",
        title: "Shelter in place",
        subtitle: "Stay at your location until further information. Leaving could put life at risk and impede operations.",
        audioTime: audioTimings["Shelter in place"],
      },
    ],
  };
  
  const goBagSection = {
    title: "Go bag",
    data: [
      {
        key: "N95 respirator",
        title: "N95 respirator",
        subtitle: "Filters out harmful particles in wildfire smoke, protecting lungs",
        audioTime: audioTimings["N95 respirator"],
      },
      {
        key: "Goggles",
        title: "Goggles",
        subtitle: "Prevents eye irritation and injury from ash.",
        audioTime: audioTimings["Goggles"],
      },
      {
        key: "First aid kit",
        title: "First aid kit",
        subtitle: "Provide essential supplies for treating injuries during emergencies",
        audioTime: audioTimings["First aid kit"],
      },
      {
        key: "Key documents",
        title: "Key documents",
        subtitle: "Avoid losing vital documents like birth certificates, passports, insurance and property records.",
        audioTime: audioTimings["Key documents"],
      },
      {
        key: "Food and water supplies",
        title: "Food and water supplies",
        subtitle: "Needed to sustain yourself and family during and after the evacuation",
        audioTime: audioTimings["Food and water supplies"],
      },
      {
        key: "Flashlight and radio",
        title: "Flashlight and radio",
        subtitle: "Avoid being stranded due to lack of access to power or internet during an evacuation.",
        audioTime: audioTimings["Flashlight and radio"],
      },
    ],
  };
  
  const petsSection = {
    title: "Pets",
    data: [
      {
        key: "Pet leashes",
        title: "Pet leashes",
        subtitle: "Have pet leashes available to take pets along with you",
        audioTime: audioTimings["Pet leashes"],
      },
      {
        key: "Carrier or crates",
        title: "Carrier or crates",
        subtitle: "If needed, have carrier or crates ready for transporting your pets",
        audioTime: audioTimings["Carrier or crates"],
      },
      {
        key: "Pet food and water supplies",
        title: "Pet food and water supplies",
        subtitle: "2-weeks worth of food/water supplies needed to sustain pets during and after the evacuation",
        audioTime: audioTimings["Pet food and water supplies"],
      },
      {
        key: "Pet medical supplies",
        title: "Pet medical supplies",
        subtitle: "2-weeks worth of medical supplies needed to sustain pets during and after the evacuation",
        audioTime: audioTimings["Pet medical supplies"],
      },
      {
        key: "Plan with neighbors",
        title: "Plan with neighbors",
        subtitle: "If you’re unavailable, plan with neighbors to help retrieve pets during a wildfire.",
        audioTime: audioTimings["Plan with neighbors"],
      },
    ],
  };
  
  const newSections = [
    alertSection,
    goBagSection,
    ...(selectedWorries.includes("Pets") ? [petsSection] : []),
  ];
  

  const handleConvertToPodcast = async () => {
    const uploadPoint = Date.now();
    setPodcastUploadPoint(uploadPoint);
    const englishSections = [
      {
        title: "What do they mean",
        data: [
          {
            key: 'Evacuation Order',
            title: messagesForEvacuation["Evacuation Order"].scenario_title["EN"],
            source_agency: messagesForEvacuation["Stay in car"].source_agency,
            subtitle: messagesForEvacuation["Evacuation Order"].message["EN"],
            impact: messagesForEvacuation["Evacuation Order"].impact["EN"],
          },
          {
            key: 'Evacuation Warning',
            title: messagesForEvacuation["Evacuation Warning"].scenario_title["EN"],
            source_agency: messagesForEvacuation["Stay in car"].source_agency,
            subtitle: messagesForEvacuation["Evacuation Warning"].message["EN"],
            impact: messagesForEvacuation["Evacuation Warning"].impact["EN"],
          },
          {
            key: 'Shelter in Place',
            title: messagesForEvacuation["Shelter in Place"].scenario_title["EN"],
            source_agency: messagesForEvacuation["Stay in car"].source_agency,
            subtitle: messagesForEvacuation["Shelter in Place"].message["EN"],
            impact: messagesForEvacuation["Shelter in Place"].impact["EN"],
          },
          {
            key: 'Red Flag Day',
            title: messagesForEvacuation["Red Flag Day"].scenario_title["EN"],
            source_agency: messagesForEvacuation["Stay in car"].source_agency,
            subtitle: messagesForEvacuation["Red Flag Day"].message["EN"],
            impact: messagesForEvacuation["Red Flag Day"].impact["EN"],
          }
        ]
      },
      {
        title: "Evacuate Safely",
        data: [
          {
            key: 'Stay in car',
            title: messagesForEvacuation["Stay in car"].scenario_title["EN"],
            source_agency: messagesForEvacuation["Stay in car"].source_agency,
            subtitle: messagesForEvacuation["Stay in car"].message["EN"],
            impact: messagesForEvacuation["Stay in car"].impact["EN"],
          },
          {
            key: 'Uphill',
            title: messagesForEvacuation["Uphill"].scenario_title["EN"],
            source_agency: messagesForEvacuation["Stay in car"].source_agency,
            subtitle: messagesForEvacuation["Uphill"].message["EN"],
            impact: messagesForEvacuation["Uphill"].impact["EN"],
          },
          {
            key: 'Paved Roads',
            title: messagesForEvacuation["Paved Roads"].scenario_title["EN"],
            source_agency: messagesForEvacuation["Stay in car"].source_agency,
            subtitle: messagesForEvacuation["Paved Roads"].message["EN"],
            impact: messagesForEvacuation["Paved Roads"].impact["EN"],
          },
          {
            key: 'Fire Roads',
            title: messagesForEvacuation["Fire Roads"].scenario_title["EN"],
            source_agency: messagesForEvacuation["Stay in car"].source_agency,
            subtitle: messagesForEvacuation["Fire Roads"].message["EN"],
            impact: messagesForEvacuation["Fire Roads"].impact["EN"],
          }
        ]
      },
      {
        title: "Save property",
        data: [
          {
            key: 'Gas Shutoff and Tank Safety',
            title: messagesForEvacuation["Gas Shutoff and Tank Safety"].scenario_title["EN"],
            source_agency: messagesForEvacuation["Gas Shutoff and Tank Safety"].source_agency,
            subtitle: messagesForEvacuation["Gas Shutoff and Tank Safety"].message["EN"],
            impact: messagesForEvacuation["Gas Shutoff and Tank Safety"].impact["EN"],
          },
          {
            key: 'Garden Hose Setup',
            title: messagesForEvacuation["Garden Hose Setup"].scenario_title["EN"],
            source_agency: messagesForEvacuation["Garden Hose Setup"].source_agency,
            subtitle: messagesForEvacuation["Garden Hose Setup"].message["EN"],
            impact: messagesForEvacuation["Garden Hose Setup"].impact["EN"],
          },
          {
            key: 'Water Buckets for Protection',
            title: messagesForEvacuation["Water Buckets for Protection"].scenario_title["EN"],
            source_agency: messagesForEvacuation["Water Buckets for Protection"].source_agency,
            subtitle: messagesForEvacuation["Water Buckets for Protection"].message["EN"],
            impact: messagesForEvacuation["Water Buckets for Protection"].impact["EN"],
          }
        ]
      }
    ];
    const appendedText = " Marin Avenue is very congested but safe during evacuation. Grizzly peak boulevard is very congested but safe during evacuation";
    const podcastContent = JSON.stringify(englishSections) + appendedText;
    generatePodcastScript(podcastContent, selectedLanguage, uploadPoint);
    const db = getDatabase();
    const podcastRef = ref(db, `/generated_podcast/${uploadPoint}`);
    onValue(podcastRef, (snapshot) => {
      const val = snapshot.val();
      if (val && typeof val === 'string') {
        setPodcastStream(val);
      }
    });
  };

  const audioSegments = React.useMemo(() => {
    const sorted = Object.entries(routesAudioTimings)
      .map(([title, start]) => ({ title, start }))
      .sort((a, b) => a.start - b.start);
    sorted.forEach((seg, i) => seg.end = i < sorted.length - 1 ? sorted[i + 1].start : Infinity);
    return sorted;
  }, []);

  const nodeIdForTime = (t) => {
    const seg = audioSegments.find(s => t >= s.start && t < s.end);
    if (!seg) return null;
    const item = routeChecklistItems.find(i => i.title === seg.title);
    return item?.nodeId ?? null;      // null for “Assumptions” & “Plan”
  };

  const updateRouteOpacity = (activeNodeId) => {
    routesDataRef.current.forEach(r => {
      let alpha = 1;
      if (activeNodeId) {
        alpha = r.destNodeId === activeNodeId ? 1 : 0.3;
      }
      r.routePolylines.forEach(p => p.setOptions({ strokeOpacity: alpha }));
      r.destMarker.setOpacity(alpha);
    });
  };

  const handleLocationSearch = async () => {
    const query = searchText.trim();
    if (!query) return;
  
    try {
      setIsSearchingLoc(true);
      const { lat, lng } = await geocodeAddress(query, "", "");      // already imported
      const latNum = +lat, lngNum = +lng;
  
      setSelectedLocation({ lat: latNum, lng: lngNum });
  
      if (mapRef.current) {
        modifyMapCamera(
          mapRef.current,
          { lat: latNum, lng: lngNum }, // target centre
          14.5,                           // target zoom
          1000                          // duration (ms)
        );
      }
      if (selectedSimulation) drawRoutes(latNum, lngNum, time, selectedSimulation);
    } catch (err) {
      console.error("Geocode failed:", err);
    } finally {
      setIsSearchingLoc(false);
    }
  };

  const modifyMapCamera = (map, endCenter, endZoom, duration = 1000) => {
    const startCenter = map.getCenter().toJSON();
    const startZoom   = map.getZoom();
    const frames      = Math.round((duration / 1000) * 60); // ~60 fps
    let frame = 0;
  
    const latDiff  = endCenter.lat - startCenter.lat;
    const lngDiff  = endCenter.lng - startCenter.lng;
    const zoomDiff = endZoom       - startZoom;
  
    const step = () => {
      frame += 1;
      const t    = frame / frames;
      const ease = t < .5 ? 2 * t * t : -1 + (4 - 2 * t) * t;   // ease-in/out
  
      map.setCenter({
        lat: startCenter.lat + latDiff * ease,
        lng: startCenter.lng + lngDiff * ease
      });
      map.setZoom(startZoom + zoomDiff * ease);
  
      if (frame < frames) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };


  return (
    <div style={{ display: "flex", flexDirection: "row", padding: "20px", color: "#000" }}>
      {/* Left Pane */}
      <div style={{ flex: "0 0 40%", marginRight: "20px" }}>
        <h1>Personalized Wildfire Preparedness</h1>
        
        {/* Section 1: Worries */}
        <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
        {WORRIES.map((worry) => (
          <label key={worry.key} style={{ whiteSpace: "nowrap" }}>
            <input
              type="checkbox"
              value={worry.key}
              checked={selectedWorries.includes(worry.key)}
              onChange={(e) => {
                const value = e.target.value;
                setSelectedWorries((prev) =>
                  prev.includes(value)
                    ? prev.filter((w) => w !== value)
                    : [...prev, value]
                );
              }}
            />
            {worry.label}
          </label>
        ))}
      </div>
        
        {/* Tabbed Section: Prepare Tab, Podcast Audio & Checklist */}
        <div style={{ marginTop: "20px" }}>
          <div style={{ display: "flex", borderBottom: "2px solid #ccc" }}>
            <div
              onClick={() => setSelectedTab("actions")}
              style={{
                padding: "10px 20px",
                cursor: "pointer",
                borderBottom: selectedTab === "actions" ? "2px solid blue" : "none"
              }}
            >
              Prepare
            </div>
            <div
              onClick={() => setSelectedTab("routes")}
              style={{
                padding: "10px 20px",
                cursor: "pointer",
                borderBottom: selectedTab === "routes" ? "2px solid blue" : "none"
              }}
            >
              Routes
            </div>
          </div>
          <div style={{ padding: "20px", border: "1px solid #ccc" }}>
            {selectedTab === "actions" && (
              <div>
                {podcastAudioUrl && (
                  <div style={{ marginBottom: "20px" }}>
                    <audio
                      controls
                      src={podcastAudioUrl}
                      ref={podcastAudioRef}
                      style={{ width: "100%" }}
                    >
                      Your browser does not support the audio element.
                    </audio>
                  </div>
                )}
                <style>
                  {`
                    .checklist-item {
                      width: 350px;
                      display: flex;
                      align-items: center;
                      justify-content: space-between;
                      border: 1px solid #ccc;
                      border-radius: 4px;
                      padding: 5px;
                      position: relative;
                    }
                    .checklist-item .play-button {
                      display: none;
                    }
                    .checklist-item:hover .play-button {
                      display: block;
                    }
                  `}
                </style>
                {newSections.map((section, index) => (
                  <div key={index} style={{ marginBottom: "20px" }}>
                    <h3>{section.title}</h3>
                    <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                      {section.data && section.data.map((item) => (
                        <div key={item.key} className="checklist-item">
                          <label style={{ display: "flex", alignItems: "center", flex: 1 }}>
                            <input
                              type="checkbox"
                              checked={checkedItems[item.key] || false}
                              onChange={() =>
                                setCheckedItems({
                                  ...checkedItems,
                                  [item.key]: !checkedItems[item.key]
                                })
                              }
                              style={{ marginRight: "8px" }}
                            />
                            <span>{displayLabels[item.key] || item.title}</span>
                          </label>
                          <button
                            className="play-button"
                            onClick={() => {
                              const startTime = audioTimings[item.key];
                              if (startTime !== undefined) {
                                playSection(startTime);
                              }
                            }}
                            style={{
                              backgroundColor: "#007BFF",
                              color: "#fff",
                              border: "none",
                              padding: "5px 10px",
                              borderRadius: "4px",
                              cursor: "pointer"
                            }}
                          >
                            Why?
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            )}

            {selectedTab === "routes" && (
              <div>
                {/* ❶ Audio player */}
                {routesAudioUrl && (
                  <div style={{ marginBottom: "20px" }}>
                    <audio
                      controls
                      src={routesAudioUrl}
                      ref={routesAudioRef}
                      style={{ width: "100%" }}
                    />
                  </div>
                )}
            
                {/* ❷ Checklist (same hover‑play style you used before) */}
                <style>{`
                  .route-check-item {
                    width: 350px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    border: 1px solid #ccc;
                    border-radius: 4px;
                    padding: 5px;
                    position: relative;
                  }
                  .route-check-item .play-button { display: none; }
                  .route-check-item:hover .play-button { display: block; }
                `}</style>
            
                {routeChecklistItems.map((item) => (
                  <div key={item.key} className="route-check-item" style={{ marginBottom: 10 }}>
                    <label style={{ display: "flex", alignItems: "center", flex: 1 }}>
                      <input
                        type="checkbox"
                        checked={false /* no persistence needed here */}
                        onChange={() => {}}
                        style={{ marginRight: 8 }}
                      />
                      <span>{item.title}</span>
                    </label>
                    <button
                      className="play-button"
                      onClick={() => {
                        const t = routesAudioTimings[item.title];
                        if (typeof t === "number") playRouteSection(t);
                      }}
                      style={{
                        background: "#007BFF",
                        color: "#fff",
                        border: "none",
                        padding: "5px 10px",
                        borderRadius: 4,
                        cursor: "pointer"
                      }}
                    >
                      Play
                    </button>
                  </div>
                ))}
                {travelExperiences && (<button
                  onClick={handleGetTravelExperience}
                  disabled={!selectedLocation}
                  style={{
                    padding: '8px 16px',
                    backgroundColor: selectedLocation ? '#007BFF' : '#999',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: selectedLocation ? 'pointer' : 'not-allowed',
                    marginBottom: '16px'
                  }}
                >
                  Get travel narrative
                </button>
                )}

                {travelExperiences && !travelExpNarrativeStream && (
                  <pre style={{ maxHeight: 300, overflow: 'auto', background: '#f9f9f9', padding: 8 }}>
                    {JSON.stringify(travelExperiences, null, 2)}
                  </pre>
                )}

                {travelExpNarrativeStream && (
                  <pre style={{ maxHeight: 700, width: 700, overflow: 'auto', background: '#f9f9f9', padding: 8 }}>
                    {travelExpNarrativeStream}
                  </pre>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
      
      {/* Right Pane */}
      <div style={{ flex: "0 0 58%" }}>
        <div style={{ marginBottom: "20px", position: "relative" }}>
          {/* Simulation Dropdown & Time Slider */}
          <select
            value={selectedSimulation?.id || ''}
            onChange={handleSimulationChange}
            style={{ padding:'5px', borderRadius:'4px', fontSize:'14px',
                    border:'1px solid #444', marginRight:'20px' }}>
            {simulations.map(sim => (
              <option key={sim.id} value={sim.id}>{sim.name}</option>
            ))}
          </select>
          <div style={{ paddingTop: "20px", marginBottom: "10px" }}>
            <input
              type="range"
              min="0"
              max={selectedSimulation?.total_time || 0}
              step="100"
              value={time}
              onChange={handleTimeChange}
              style={{
                width: "100%",
                marginBottom: "10px",
                backgroundColor: "#3A3A3A"
              }}
            />
            <div style={{ textAlign: "center" }}>Delayed by {formatTime(time)}</div>
          </div>


          <div style={{ position: "relative", marginTop: 10 /* NEW wrapper */ }}>
            <div
              style={{
                position: "absolute",
                top: 10, left: 0, right: 0,
                width: "90%", maxWidth: 500, margin: "0 auto",
                zIndex: 5
              }}
            >
              <div
                style={{
                  display: "flex", alignItems: "center",
                  background: "#fff", borderRadius: 24,
                  padding: "6px 12px", boxShadow: "0 1px 4px rgba(0,0,0,.3)"
                }}
              >
                {/* search icon */}
                <span style={{ fontSize: 20, color: "#666", marginRight: 8 }}>🔍</span>

                {/* input */}
                <input
                  value={searchText}
                  onChange={e => setSearchText(e.target.value)}
                  onKeyDown={e => { if (e.key === "Enter") { e.preventDefault(); handleLocationSearch(); } }}
                  placeholder="Search for a place…"
                  style={{ flex: 1, border: "none", outline: "none", fontSize: 16, background: "transparent" }}
                />

                {/* spinner OR “go” icon */}
                {isSearchingLoc ? (
                  <div
                    style={{
                      width: 18, height: 18, borderRadius: "50%",
                      border: "3px solid #ccc", borderTopColor: "#2563EB",
                      animation: "spin 0.9s linear infinite"
                    }}
                  />
                ) : (
                  <span
                    onClick={handleLocationSearch}
                    title="Search"
                    style={{ fontSize: 20, color: "#666", cursor: "pointer" }}
                  >⏎</span>
                )}
              </div>
            </div>

            <style>{`@keyframes spin{from{transform:rotate(0)}to{transform:rotate(360deg)}}`}</style>
            
            
            <LoadScript googleMapsApiKey={GOOGLE_MAPS_API_KEY}>
              <GoogleMap
                mapContainerStyle={containerStyle}
                center={center}
                zoom={14.5}
                onLoad={(map) => {
                  mapRef.current = map;
                  loadFireOverlay();
                }}
                onClick={handleMapClick}
                options={{
                  styles: darkMapStyle,
                  disableDefaultUI: true,
                  mapTypeControl: false,
                  zoomControl: false,
                  streetViewControl: false,
                  fullscreenControl: false,
                  scaleControl: false,
                  rotateControl: false,
                  keyboardShortcuts: false
                }}
              >
                {/* Render additional overlays, e.g., car markers via state */}
                {carOverlays}
              </GoogleMap>
            </LoadScript>
            </div>
        </div>
      </div>
    </div>
  );
};

export default WildfirePlanningPage;
